import React, { useCallback, useMemo, useEffect, useState, Fragment } from 'react';
import clsx from 'clsx';
import { NavItem, Nav, NavLink, Card, CardText, Col, Row } from 'reactstrap';
import styled from 'styled-components';

import useSidebarMenuOptions from './useSidebarMenuOptions';
import { useEditorActions, useEditorState } from '../editor-context'

function SidebarMenuList({ tabs, currentTab, onClick }) {

    const handleClick = (tab) => () => {
        onClick(tab)
    }

    return (
        <Nav tabs vertical className="bg-light h-100">
            {tabs.map((option) => (
                option.shouldShow() &&
                <NavItem key={`tab-${option.name}`} active={option.name === currentTab.name}  className={clsx('pointer border p-3', option.name === currentTab.name && 'border-light-gray' )} title={option.title} id={`right-sidebar-${option.name}`} onClick={handleClick(option)}>
                    {option.showAlert &&
                        <i className="fas fa-exclamation-triangle text-warning" style={{position: 'absolute'}} />
                    }
                    <img src={option.img} alt={option.title} height="25px" />
                </NavItem>
            ))}
        </Nav>
    )
}

function SidebarHeader({ title, subtitle }) {
    return (
        <Card className="bg-light p-1 rounded-0">
            <CardText className="font-weight-bold">
                {title}
                <br />
                <small className="">{subtitle}</small>
            </CardText>
        </Card>
    )
}

const Root = styled.div`
    display: flex;
    height: 100%;
`;

const MainContainer = styled.div`
    width: calc(100% - 55px);
    min-height: 100%;
`
const SidebarHeaderContainer =  styled(SidebarHeader)`
    height: 50px
`;

const ContentContainer = styled.div`
    height: calc( 100% - 50px);
    overflow-y: auto;
`

const NavbarContainer =  styled.div`
    width: 55px;
    min-heiht: 100%;
    margin: 0;
    padding: 0;
    list-style-type: none;
`;

function Sidebar() {
    const { setCurrentSidebarTab } = useEditorActions();
    const { currentSidebarTab, document: doc, documentType, mode, isEditable, status } = useEditorState();
    const {tabs, defaultTab} = useSidebarMenuOptions({ 
        defaultTab: doc.elements?.length && documentType === 'trato' && mode === 'contract' && isEditable ? 'preview' : 'configuration', 
        onDefaultTabChange: (defaultTab) => {
            // if (!currentSidebarTab.name) {
                setCurrentSidebarTab(defaultTab)
            // }
        }
    });


    const handleTabChange = (tab) => {
        setCurrentSidebarTab(tab)
    }

    return (
        <Root className="sidebar-root">
            {/* {
                status === 'loading' && !doc._id ? (
                    <MainContainer className="sidebar-content bg-light d-flex align-items-center justify-content-center h-100">
                        <TratoLoader size="xl" /> 
                    </MainContainer>
                ) : ( */}
                    <MainContainer className="sidebar-content bg-light border-left">
                        <SidebarHeaderContainer title={currentSidebarTab.title} subtitle={currentSidebarTab.subtitle} />
                        <ContentContainer>
                            {currentSidebarTab.Component && <currentSidebarTab.Component />}
                            
                        </ContentContainer>
                    </MainContainer>
                {/* ) */}
            {/* } */}
            <NavbarContainer  className="sidebar-navbar border-left">
                <SidebarMenuList onClick={handleTabChange} tabs={tabs} currentTab={currentSidebarTab} />
            </NavbarContainer>
        </Root>
    )
}
export default Sidebar;